export const groupByQueue = data => {
  const grouped = data.reduce((result, item) => {
    const { queue, title } = item;

    if (!result[queue]) result[queue] = [title];
    else result[queue].push(title);

    return result;
  }, {});

  const priority = ['I очередь', 'II очередь'];
  const ordered = {};

  priority.forEach(q => {
    if (grouped[q]) {
      ordered[q] = grouped[q];
      delete grouped[q];
    }
  });

  // Добавляем оставшиеся очереди
  Object.keys(grouped).forEach(q => {
    ordered[q] = grouped[q];
  });

  return ordered;
};
